import { all, takeEvery, takeLatest, put, call, select } from 'redux-saga/effects';
import renderNotification from '../../helpers/notifications/renderNotification';
import { NOTIFICATION_MESSAGES } from '../../localization/Notifications/dictionary';
import { selectSelectedOrganizationId } from '../organizations/selectors';
import {
  onGetMessageTemplates,
  onCreateMessageTemplate,
  onUpdateMessageTemplate,
  onDeleteMessageTemplate,
  onGetPredefinedMessageTemplates
} from './api';
import {
  getMessageTemplates,
  getMessageTemplatesSucceeded,
  getMessageTemplatesFailed,
  getPredefinedMessageTemplates,
  getPredefinedMessageTemplatesSucceeded,
  getPredefinedMessageTemplatesFailed,
  createMessageTemplate,
  createMessageTemplateSucceeded,
  createMessageTemplateFailed,
  updateMessageTemplate,
  updateMessageTemplateSucceeded,
  updateMessageTemplateFailed,
  deleteMessageTemplate,
  deleteMessageTemplateSucceeded,
  deleteMessageTemplateFailed
} from './slice';

const { message_template_create_success, message_template_update_success, message_template_delete_success } =
  NOTIFICATION_MESSAGES;

export function* getMessageTemplatesWorker({ payload }) {
  try {
    const messageTemplates = yield call(onGetMessageTemplates, payload);
    yield put(getMessageTemplatesSucceeded(messageTemplates.data));
  } catch {
    yield put(getMessageTemplatesFailed());
  }
}

export function* getPredefinedMessageTemplatesWorker() {
  try {
    const messageTemplates = yield call(onGetPredefinedMessageTemplates);
    yield put(getPredefinedMessageTemplatesSucceeded(messageTemplates.data));
  } catch {
    yield put(getPredefinedMessageTemplatesFailed());
  }
}

export function* createMessageTemplateWorker({ payload }) {
  const { message, callback } = payload;
  try {
    yield call(onCreateMessageTemplate, message);
    renderNotification({ type: 'success', message: message_template_create_success });
    yield put(createMessageTemplateSucceeded());
    callback?.();
  } catch {
    yield put(createMessageTemplateFailed());
  }
}

export function* updateMessageTemplateWorker({ payload }) {
  const { message, callback } = payload;
  try {
    yield call(onUpdateMessageTemplate, message);
    renderNotification({ type: 'success', message: message_template_update_success });
    yield put(updateMessageTemplateSucceeded());
    callback?.();
  } catch {
    yield put(updateMessageTemplateFailed());
  }
}

export function* deleteMessageTemplateWorker({ payload }) {
  const { id, callback } = payload;
  try {
    yield call(onDeleteMessageTemplate, id);
    renderNotification({ type: 'success', message: message_template_delete_success });
    yield put(deleteMessageTemplateSucceeded());
    callback?.();
  } catch {
    yield put(deleteMessageTemplateFailed());
  }
}

export function* getMessageTemplatesByOrganizationWorker() {
  const selectedOrganizationId = yield select(selectSelectedOrganizationId);
  if (selectedOrganizationId) {
    yield put(
      getMessageTemplates({
        organization_id: selectedOrganizationId,
        paging: false
      })
    );
  }
}

export default function* messageTemplatesSaga() {
  yield all([
    takeLatest(getMessageTemplates.type, getMessageTemplatesWorker),
    takeLatest(getPredefinedMessageTemplates.type, getPredefinedMessageTemplatesWorker),

    takeLatest(createMessageTemplate.type, createMessageTemplateWorker),
    takeLatest(updateMessageTemplate.type, updateMessageTemplateWorker),
    takeLatest(deleteMessageTemplate.type, deleteMessageTemplateWorker),

    takeEvery(
      [createMessageTemplateSucceeded.type, updateMessageTemplateSucceeded.type, deleteMessageTemplateSucceeded.type],
      getMessageTemplatesByOrganizationWorker
    )
  ]);
}
